import axios, { AxiosInstance } from 'axios'

import { AwsApi } from 'src/data/aws/AwsService'
import { APIRequest, AWSExceptionPayload } from 'src/data/common/type'

export class API {
  api: AxiosInstance
  constructor(baseURL = '') {
    if (!baseURL) {
      throw new Error('Base Url is required')
    }
    this.api = axios.create({
      baseURL,
    })
  }

  async call(requestParams: APIRequest): Promise<any> {
    try {
      const { data } = await this.api.request({
        url: requestParams.url,
        data: requestParams.data,
        params: requestParams.params,
        method: requestParams.method,
        headers: requestParams.headers,
        ...requestParams.options,
      })
      return data
    } catch (e: any) {
      let message = ''
      let status = 500
      if (e.response) {
        message = e.response.data.message
        if (e.response.data.status) {
          status = e.response.data.status
        } else {
          status = e.response.status
        }
      } else if (e.request) {
        message = e.request
      } else {
        message = e.message
      }
      const log = {
        origin: 'backend',
        message,
        status,
        url: requestParams.url,
        data: requestParams.data,
        params: requestParams.params,
        method: requestParams.method,
        headers: requestParams.headers,
      }
      return AwsApi.logWebExceptions(log).then((result: AWSExceptionPayload) => {
        const error = {
          result: message,
          status,
          cloudwatch_link: result.cloudwatch_link,
        }
        throw Error(JSON.stringify(error))
      })
    }
  }
}
